import React from "react";
import { useSelector } from "react-redux";
import { selectCateringCartPackages } from "../../redux/features/restaurants/restaurantSelectors";

/**
 * AdditionalServices component displays additional service packages
 * that users can add to their order
 * @param {Array} packages - List of additional service packages
 * @param {Function} onSelectPackage - Callback when a package is clicked
 * @param {number|null} selectedPackageId - Currently selected additional package ID
 */
const AdditionalServices = ({ packages, onSelectPackage, selectedPackageId }) => {
  const cateringCartPackages = useSelector(selectCateringCartPackages);
  
  if (!packages || packages.length === 0) {
    return null;
  }

  // Helper to check if a package is in the cart
  const isPackageInCart = (packageId) => {
    return cateringCartPackages?.some(pkg => pkg.id === packageId) || false;
  };

  return (
    <div className="w-full px-6 py-4 bg-white border-t border-gray-200">
      <h2 className="text-xl font-bold text-gray-800 mb-4">Additional Services</h2>
      
      <div className="flex flex-wrap sm:justify-start justify-center gap-4">
        {packages.map((pkg) => {
          const inCart = isPackageInCart(pkg.id);
          const isSelected = selectedPackageId === pkg.id;
          
          return (
            <button
              key={pkg.id}
              className={`flex items-center p-4 min-h-[85px] text-xs text-gray-50 rounded-xl font-bold transition-all duration-200 hover:shadow-lg ${
                isSelected
                  ? "bg-white border-2 border-amber-100 shadow-md"
                  : inCart
                  ? "bg-white border-2 border-amber-400 hover:border-amber-500 shadow-sm"
                  : "bg-white border-2 border-gray-150 hover:border-amber-50"
              } ${!pkg.available ? 'opacity-50 cursor-not-allowed' : ''}`}
              onClick={() => onSelectPackage(pkg)}
              disabled={!pkg.available}
            >
              <div className="text-left w-full">
                <div className="font-bold text-gray-800 mb-1 line-clamp-2">
                  {pkg.name_en || pkg.title || pkg.name}
                </div>
                {pkg.min_pax && pkg.max_pax && pkg.min_pax !== "" && pkg.max_pax !== "" && (
                  <div className="text-xs text-gray-600">
                    {pkg.min_pax}-{pkg.max_pax} PAX
                  </div>
                )}
                {inCart && !isSelected && (
                  <div className="text-xs text-amber-600 mt-1 font-semibold">
                    ✓ In Cart
                  </div>
                )}
                {!pkg.available && (
                  <div className="text-xs text-red-500 mt-1">
                    Unavailable
                  </div>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AdditionalServices;

